<div class="modal-header">
	<div>
		<h5 class="modal-title">Adjust Stock</h5>
		<div class="subheading">
			<strong>{{ inventoryItemLocation.inventoryItemData?.name }}</strong>
			at
			<strong>{{ inventoryItemLocation.locationData?.name }}</strong>
		</div>
	</div>
	<button type="button" class="btn-close" (click)="closeModal()" aria-label="Close"></button>
</div>
<div class="modal-body">
	<div class="section">
		<div class="section-item">
			Current Quantity: <strong>{{ inventoryItemLocation.quantity }}</strong>
		</div>
		<div class="section-item">
			New Quantity: <strong [class.text-danger]="newQuantity < 0">{{ newQuantity }}</strong>
		</div>
	</div>

	<div class="form-container">
		<app-dropdown-control
			[formGroup]="form"
			name="changeType"
			label="Change Type"
			[showLabel]="true"
			placeholder="Select Change Type"
			[options]="changeTypeOptions"
		></app-dropdown-control>

		<app-standard-control
			type="number"
			name="quantity"
			[formGroup]="form"
			label="Quantity"
			labelPlacement="above"
			placeholder="Quantity"
		></app-standard-control>

		<app-textarea-control
			[resizable]="true"
			[heightPx]="100"
			name="reason"
			[formGroup]="form"
			label="Reason"
			placeholder="Reason for stock adjustment"
		></app-textarea-control>
	</div>
</div>
<div class="modal-footer">
	<button type="button" class="btn btn-sm btn-outline-secondary btn-width" (click)="closeModal()">Cancel</button>
	<button
		type="button"
		[disabled]="form.invalid || newQuantity < 0 || isAddingStock"
		class="btn btn-sm btn-primary btn-width"
		(click)="submit()"
		data-id="submit"
	>
		<ng-container *ngIf="isAddingStock; else notLoading">
			<div class="spinner-border spinner-border-sm" role="status">
				<span class="visually-hidden">Loading...</span>
			</div>
		</ng-container>
		<ng-template #notLoading> Adjust Stock</ng-template>
	</button>
</div>
